/// <amd-module name="VSS/Diagnostics/UI/Components/Resources/Resources" />
import * as React from "react";

import { Components, IVssComponentContext, VssComponent } from "VSS/Platform/Layout";
import { IVssPerformanceService, IVssScenario } from "VSS/Platform/Performance";
import { IVssPerformanceDiagnosticsService, PerfSectionDataSegment } from "VSS/Diagnostics/PerfBar";
import { Section } from "VSS/Diagnostics/UI/Section";
import { DataProviderResult } from "VSS/Platform/Contracts/Contributions";

interface ResourcesState {
    resourceSegments: PerfSectionDataSegment[];
}

class Resources extends VssComponent<{}, ResourcesState> {
    constructor(props: Readonly<{}>, context: IVssComponentContext) {
        super(props, context);

        this.state = {
            resourceSegments: this.getSectionData()
        };
    }

    public render(): JSX.Element {
        return <Section key="resoruces-section" dataSegments={this.state.resourceSegments} sectionLabel="Resources" />;
    }

    public componentDidMount() {
        super.componentDidMount();

        const performanceService = this.context.pageContext.getService<IVssPerformanceService>("IVssPerformanceService");
        performanceService.subscribe(this.scenarioComplete, "scenarioComplete");
    }

    public componentWillUnmount() {
        super.componentWillUnmount();

        const performanceService = this.context.pageContext.getService<IVssPerformanceService>("IVssPerformanceService");
        performanceService.unsubscribe(this.scenarioComplete, "scenarioComplete");
    }

    private getSectionData(): PerfSectionDataSegment[] {
        const performanceDiagnosticsService = this.context.pageContext.getService<IVssPerformanceDiagnosticsService>(
            "IVssPerformanceDiagnosticsService"
        );
        const performanceService = this.context.pageContext.getService<IVssPerformanceService>("IVssPerformanceService");
        const performanceData = performanceService.getPerformanceData();
        let resourceSegments: PerfSectionDataSegment[] = [];

        if (performanceDiagnosticsService.isBundlingEnabled()) {
            if (performanceData.initialPageLoad) {
                resourceSegments = [
                    {
                        segmentLabel: "Scripts",
                        segmentContent:
                            performanceData.contentData.scriptsCount + " (" + this.getSizeText(performanceData.contentData.scriptSize) + ")"
                    },
                    {
                        segmentLabel: "CSS",
                        segmentContent: performanceData.contentData.cssCount + " (" + this.getSizeText(performanceData.contentData.cssSize) + ")"
                    }
                ];
                if (performanceData.contentData.ajaxCount) {
                    resourceSegments.push({
                        segmentLabel: "Ajax",
                        segmentContent: performanceData.contentData.ajaxCount + ""
                    });
                }
                if (performanceData.contentData.other) {
                    resourceSegments.push({
                        segmentLabel: "Other",
                        segmentContent: performanceData.contentData.other
                    });
                }
            } else {
                resourceSegments = [
                    {
                        segmentLabel: "",
                        segmentContent: "Unavailable on FPS. Reload for stats."
                    }
                ];
            }
        } else {
            resourceSegments = [
                {
                    segmentLabel: "Scripts",
                    segmentContent: performanceDiagnosticsService.isDebugEnabled() ? "debug" : "minified"
                },
                {
                    segmentLabel: "Bundling",
                    segmentContent: "disabled"
                }
            ];
        }

        const dataProviderResult: DataProviderResult = (window as any)["dataProviders"];
        if (dataProviderResult) {
            let dataProviderSize = -1;
            try {
                dataProviderSize = JSON.stringify(dataProviderResult.data).length / 1024;
            } catch {
                // Ignore any error here
            }

            resourceSegments.push({
                segmentLabel: "Data Providers",
                segmentContent: `${Object.keys(dataProviderResult.data).length} (${dataProviderSize.toFixed(0)} KB)`
            });
        }

        return resourceSegments;
    }

    private getSizeText(size: number) {
        var text = "";
        if (size >= 0) {
            var kb = size / 1024;
            text = Math.round(kb) + " KB";
        }
        return text;
    }

    private scenarioComplete = (scenario: IVssScenario) => {
        if (scenario.isPageInteractive) {
            this.setState({ resourceSegments: this.getSectionData() });
        }
    };
}

Components.add("perfbar.resourcesSection", Resources);
